import FeedbackReportModal from './FeedbackReportModal';

export default FeedbackReportModal;
